var _rect, _rect2, _rect3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeaturesStandardArc1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "232.4px",
    height: "302px",
    viewBox: "0 0 232.4 302",
    enableBackground: "new 0 0 232.4 302",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 37.6,
    fill: "none",
    stroke: "#646463",
    strokeWidth: 1.7568,
    strokeMiterlimit: 10,
    width: 198.4,
    height: 226.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.2,
    y: 51.8,
    fill: "none",
    stroke: "#646463",
    strokeWidth: 1.7321,
    strokeMiterlimit: 10,
    width: 170.1,
    height: 198.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 131.8,
    y: 60.8,
    fill: "#494848",
    width: 0,
    height: 40.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 0.9875,
    strokeMiterlimit: 10,
    d: "M13.4,206.5c0,0-0.9,0.3-1,1.5 c-0.1,1.1-0.2,4.9-0.2,4.9s-0.1,1.1,1.2,1.6s8.3,2,10.5,2.6s16.3,4.3,20.1,4.9s20.2,3.6,23.5,4.1s28.2,3.1,33.1,3.2 c4.9,0.2,28.6-0.1,31.9,0c3.4,0.1,19.6-1.2,23.2-1.6c3.6-0.3,23.1-3.5,24.8-3.8c1.7-0.3,26.1-6,27.3-6.4c1.2-0.4,10.6-3.2,11.2-3.4 c0.6-0.2,1.1-0.4,1.3-1.7c0.2-1.4,0.1-3.8,0.1-3.8s0.1-0.6-0.2-0.8s-1.1-0.6-1.1-0.6l-18.2,4.8l-23.6,4.4l-29.9,4.1l-37.4,1.2 l-41.7-4.1l-35.6-6.7l-18.9-5.1L13.4,206.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 0.9875,
    strokeMiterlimit: 10,
    d: "M13.8,198.4c0,0-1.3,0.6-1.3,1.7 s0,4.7,0,4.7s-0.4,0.9,0.8,1.4c1.3,0.4,8.5,2.8,10.4,3.3c1.9,0.4,21.7,4.8,26,5.8c4.3,1,29.9,5,36.3,5.5c6.4,0.4,30.1,1.9,30.1,1.9 s30.5-1.3,34.8-1.8c4.3-0.5,32.2-4.4,36.1-5.1c3.9-0.7,25.7-5.9,28.8-6.8c3.2-0.9,4-1.3,4-1.3s1,0,1-2.2c0-2.2,0-4,0-4 s-0.2-1.5-1.3-1.5c-1.1-0.1-1.1-0.5-1.1-0.5l-11.6,3.2l-40.7,8.4l-30,3.6l-30.4-0.3l-16.9-0.5l-21.3-2.9l-29.1-5.7l-20.7-6.2 l-3.6-1.1L13.8,198.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 0.9875,
    strokeMiterlimit: 10,
    d: "M13.7,189.4c0,0-1.5,0.7-1.5,2.8 s0,3.4,0,3.4s-0.4,1.5,1.5,2.3s12.6,4.4,15.1,5.1c2.5,0.7,31.4,7.8,38.1,8.7c6.7,0.9,37.8,3.8,51.8,3.5c14-0.3,49-3.7,51.7-4 c2.7-0.3,23.1-4.2,25.3-4.7c2.3-0.5,22.4-6.6,23.8-7s1.4-0.7,1.4-2.8c0-2.1,0.1-3.7-0.7-4.9c-0.8-1.2-1.6-1.5-1.6-1.5l-1-0.9 l-44.7,9.5l-25.5,3.7l-35,1.1l-24-1.8l-26.6-4.2l-47.2-9.3L13.7,189.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 0.9875,
    strokeMiterlimit: 10,
    d: "M13.2,11.8h205.4v151.9c0,0,2.3,9,2.3,14.1 c0,5.1,0,8.6,0,8.6s0.7,2.7-3.4,3.8c-4.1,1-16,4.3-25.5,6.2c-9.5,1.9-43.3,7.3-49.3,7.6c-6,0.3-33.7,1.1-46.3,0S48,197,41.3,195.5 s-25.4-6.2-27.2-6.7c-1.8-0.5-3-1.3-2.4-7c0.6-5.7,1.7-12.3,1.7-15.3S13.2,11.8,13.2,11.8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesStandardArc1);
export default __webpack_public_path__ + "static/media/FeaturesStandard_arc1.9b3de1934705ed65c25fd13b505884d5.svg";
export { ForwardRef as ReactComponent };